// extracted by mini-css-extract-plugin
export default {"wrapper":"PublicLayout_wrapper__9W-Nv","container":"PublicLayout_container__IcLBn","content-wrapper":"PublicLayout_content-wrapper__S3dUp","logo":"PublicLayout_logo__ncbCr"};